import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Menu from "@material-ui/core/Menu";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/MenuRounded";
import React, { useCallback, useState } from "react";

type OnClose = () => void;
type BurgerMenuWrapper = (children: React.ReactNode) => React.ReactNode;

export const useBurgerMenuElement = (): [OnClose, BurgerMenuWrapper] => {
    const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);
    const handleMenuOpen = useCallback((e: React.SyntheticEvent<HTMLElement>) => setAnchorEl(e.currentTarget), []);
    const handleMenuClose = useCallback(() => setAnchorEl(undefined), []);

    const classes = useStyles();
    return [
        handleMenuClose,
        (children: React.ReactNode): React.ReactNode => (
            <>
                <ListItem button={true} className={classes.burgerMenuListItem} onClick={handleMenuOpen} selected={anchorEl !== undefined} style={{}}>
                    <ListItemIcon>
                        <MenuIcon />
                    </ListItemIcon>
                </ListItem>
                <Menu
                    anchorEl={anchorEl}
                    getContentAnchorEl={null} // required that anchoring works properly and in order to avoid console error
                    anchorOrigin={{ horizontal: "right", vertical: "top" }}
                    transformOrigin={{ horizontal: "left", vertical: 8 }} // 8px = top and bottom padding of element `Menu`
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    {children}
                </Menu>
            </>
        ),
    ];
};

const useStyles = makeStyles(
    createStyles({
        burgerMenuListItem: {
            height: 40, // default height is 32px on all other use cases
            // correct padding because the icon itself is not perfectly due to `ListItem`s internal structure :-(
            paddingLeft: 14,
            paddingRight: 18,
        },
    }),
);
